import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminAuthProvider, useAdminAuth } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";

// Storefront
import StoreLayout from "@/pages/storefront/Layout";
import Home from "@/pages/storefront/Home";
import Products from "@/pages/storefront/Products";
import ProductDetail from "@/pages/storefront/ProductDetail";
import CartPage from "@/pages/storefront/Cart";
import Checkout from "@/pages/storefront/Checkout";
import OrderSuccess from "@/pages/storefront/OrderSuccess";
import CmsPage from "@/pages/storefront/CmsPage";

// Admin
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/Layout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminProductEditor from "@/pages/admin/ProductEditor";
import AdminOrders from "@/pages/admin/Orders";
import AdminOrderDetail from "@/pages/admin/OrderDetail";
import AdminPages from "@/pages/admin/Pages";
import AdminSignups from "@/pages/admin/Signups";
import AdminSettings from "@/pages/admin/Settings";
import AdminSourcing from "@/pages/admin/Sourcing";

function RequireAdmin({ children }) {
  const { user, loading } = useAdminAuth();
  if (loading)
    return (
      <div className="bls-admin flex items-center justify-center">
        <div className="text-white/60 text-sm">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <CartProvider>
          <Routes>
            {/* Storefront */}
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/success" element={<OrderSuccess />} />
              <Route path="/p/:slug" element={<CmsPage />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAdmin>
                  <AdminLayout />
                </RequireAdmin>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="products/new" element={<AdminProductEditor />} />
              <Route path="products/:id" element={<AdminProductEditor />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="orders/:id" element={<AdminOrderDetail />} />
              <Route path="pages" element={<AdminPages />} />
              <Route path="signups" element={<AdminSignups />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="sourcing" element={<AdminSourcing />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </CartProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
